import * as React from 'react';

import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import { FormResponse } from '@app/components/Pages/Area/AreaObjects';
import Musthead from '@app/components/UI/MustHead/Musthead';
import RichText from '@app/components/UI/RichText/RichText';
import StudentExternshipModal from '@app/components/UI/StudentExternshipModal/StudentExternshipModal';

const StudentExternship = () => {
	const mustHeadText = 'Are you a veterinary student? Learn more about our one-of-a-kind externship program that gives you the unique opportunity to go inside a client\'s home to help manage every aspect of a pet\'s end-of-life care.';
	const externshipText = 'Saying goodbye to our beloved animals is extremely difficult, but Lap of Love veterinarians help ease this pain by guiding animals through a peaceful passing in the comfort of their home, surrounded by their loving family members. This unique practice of veterinary medicine and the many benefits it offers is unparalleled. As a part of our 3-day externship program, you will be given the opportunity to witness this first hand. Veterinary students from around the world are invited to shadow our veterinarians on house call hospice and euthanasia appointments, as well as learn from our veterinary care coordinators, who are the first line of communication with clients enduring the end-of-life decision.';
	const mustHeadTitle = <>
		Lap of Love Student Externship<span className="unbreak-space">&nbsp;</span><span className="space">{' '}</span>Opportunities
	</>;

	const [modalVisible, setModalVisible] = React.useState(false);
	const [formSuccess, setFormSuccess] = React.useState<FormResponse>({success: false, error: ''});
	return (
		<div className="care-coordinator">
			<Musthead
				title={mustHeadTitle}
				imageSrc={require('@app/content/Student_Externship_Masthead.png')}
				text={mustHeadText}
				buttonText="Apply now"
				btnPath="/"
				onBtnClick={() => {
					setFormSuccess({success: false, error: ''});
					setModalVisible(true);
				}}
				imageAlt="Veterinary externship"
			/>
			<RichText
				title="About the externship"
				text={externshipText}
			/>
			<StudentExternshipModal
				modalVisible={modalVisible}
				setModalVisible={setModalVisible}
				formSuccess={formSuccess}
				setFormSuccess={setFormSuccess}
			/>
		</div>
	);
};

export default withSeo(StudentExternship, state => state.studentExternshipPage, 'studentExternshipPage', 'about-us/student-externship');